import { shallowEqual, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import petrovich from 'petrovich'

import { RefillTarget, RefillType } from 'app/dataTypes/acquiring/settings'
import { getLastFirst } from 'app/common/lib/names'


type Options = {
  refillTarget: RefillTarget | null
  refillType: RefillType | null
  targetID?: string
}

export default function useStep2Header(options: Options) {
  const { refillTarget, refillType, targetID } = options
  const { t } = useTranslation('finances')

  const { data, loading } = useSelector((state: any) => state.students, shallowEqual)
  const { name, gender } = (targetID && data[targetID]) || {}

  const title = (
    name // eslint-disable-line no-nested-ternary
      ? getLastFirst(petrovich({ ...name, gender }, 'genitive'))
      : (loading ? '...' : t('refill_all_children', 'всех детей (сумма делится поровну)'))
  )

  if (refillTarget === RefillTarget.Self && refillType === RefillType.Cafeteria) {
    return t('refill_account_self_cafe', 'Пополнение своего счета за питание')
  }
  if (refillTarget === RefillTarget.Self && refillType === RefillType.Primary) {
    return t('refill_account_self', 'Пополнение своего счета')
  }
  if (refillTarget === RefillTarget.Child && refillType === RefillType.Cafeteria) {
    return `${t('refill_account_child_cafe', 'Пополнение счета за питание')} ${title}`
  }
  if (refillTarget === RefillTarget.Child && refillType === RefillType.Primary) {
    return `${t('refill_account_child', 'Пополнение счета')} ${title}`
  }
  return t('refill_account_child', 'Пополнение счета')
}
